<template>
  <div class="mdc-card mgl-24 mgr-24">
    <div class="d-flex align-items-center justify-content-between pdt-12 pdl-24 pdb-12 pdr-16">
      <div class="t-subtitle3 font-m">{{ $t(contentData.msg1) }}</div>
    </div>
    <div class="detail-content pdl-24 pdr-24 pdb-24">
      <div class="t-body1 t-color-bodyGrayA font-r l-spacing-48 t-line-h-28 t-size"
           v-html="$t(contentData.msg2, {str: `<strong>${contentData.str1}</strong>`}) ">
      </div>
      <slot></slot>
    </div>

    <div class="divider"></div>
    <div class="d-flex align-items-center justify-content-between pdt-12 pdl-24 pdb-12 pdr-16">
      <div class="t-subtitle3 font-m">{{ $t(contentData.msg3) }}</div>
    </div>
    <div class="detail-content pdl-24 pdr-24 pdb-24">
      <div class="t-body1 t-color-bodyGrayA font-r l-spacing-48 t-line-h-28 t-size"
           v-html="$t(contentData.msg4, {str: `<strong>${contentData.str2}</strong>`}) ">
      </div>
    </div>

    <div class="divider"></div>
    <div class="d-flex align-items-center justify-content-between pdt-12 pdl-24 pdb-12 pdr-16">
      <div class="t-subtitle3 font-m">{{ $t(contentData.msg5) }}</div>
    </div>
    <div class="detail-content pdl-24 pdr-24 pdb-24">
      <div class="t-body1 t-color-bodyGrayA font-r l-spacing-48 t-line-h-28 t-size">
        {{ $t(contentData.msg6) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['contentData'],

  name: "contentCardBlock"
}
</script>

<style scoped>

</style>